import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import Stick from '../../es';
import { useWatcher } from './hooks';
function formPairs(listA, listB) {
    return listA.map((a) => listB.map((b) => `${a} ${b}`));
}
const verticals = ['top', 'middle', 'bottom'];
const horizontals = ['left', 'center', 'right'];
const positionGroups = formPairs(verticals, horizontals);
const alignmentGroups = formPairs(verticals, horizontals);
const Anchor = () => (_jsx("div", { style: {
        width: 35,
        height: 35,
        backgroundColor: 'rgb(24, 170, 177)',
    } }));
const Node = () => (_jsx("div", { style: {
        width: 10,
        height: 10,
        backgroundColor: '#ae0d5c',
    } }));
function FramesPerSecond({ updateOnAnimationFrame }) {
    const [fps, setFps] = useState(0);
    const lastUpdated = useRef(Date.now());
    const framesSinceLastUpdate = useRef(0);
    const measure = useCallback(() => {
        framesSinceLastUpdate.current += 1;
        const duration = Date.now() - lastUpdated.current;
        if (duration >= 1000) {
            setFps(framesSinceLastUpdate.current);
            framesSinceLastUpdate.current = 0;
            lastUpdated.current = Date.now();
        }
    }, []);
    useWatcher(measure, { updateOnAnimationFrame });
    return _jsxs("div", { children: ["FPS: ", fps] });
}
function PositionAlignOverview() {
    const [updateOnAnimationFrame, setUpdateOnAnimationFrame] = useState(false);
    const [inline, setInline] = useState(false);
    const [showNode, setShowNode] = useState(true);
    return (_jsxs("div", { children: [_jsxs("p", { children: ["The table shows all combinations of possible values for the", ' ', _jsx("code", { children: "position" }), " and ", _jsx("code", { children: "align" }), " props. The", ' ', _jsx("code", { children: "node" }), " elements are colors in red while the anchor elements (", _jsx("code", { children: "children" }), ") are colored in blue."] }), _jsxs("div", { children: [_jsx("input", { type: "checkbox", checked: inline, onChange: () => setInline(!inline) }), _jsx("code", { children: "inline" })] }), _jsxs("div", { children: [_jsx("input", { type: "checkbox", checked: updateOnAnimationFrame, onChange: () => setUpdateOnAnimationFrame(!updateOnAnimationFrame) }), _jsx("code", { children: "updateOnAnimationFrame" })] }), _jsxs("div", { children: [_jsx("input", { type: "checkbox", checked: showNode, onChange: () => setShowNode(!showNode) }), _jsx("code", { children: "showNode" })] }), _jsxs("div", { children: [_jsx("textarea", { readOnly: true, defaultValue: "resize me to check smoothness of Stick" }), _jsx(FramesPerSecond, { updateOnAnimationFrame: updateOnAnimationFrame })] }), _jsx("table", { style: {
                    textAlign: 'center',
                    borderCollapse: 'collapse',
                }, children: _jsx("tbody", { style: {
                        borderTop: '1px solid black',
                        borderRight: '1px solid black',
                    }, children: positionGroups.map((positions, i) => (_jsx("tr", { children: positions.map((position) => (_jsxs("td", { style: {
                                padding: '0 10px 10px 10px',
                                borderLeft: '1px solid black',
                                borderBottom: '1px solid black',
                                fontSize: 11,
                            }, children: [_jsxs("pre", { children: ["position=\"", position, "\""] }), _jsx("br", {}), _jsx("div", { style: { display: 'inline-block' }, children: _jsx(Stick, { inline: inline, updateOnAnimationFrame: updateOnAnimationFrame, position: position, node: showNode && _jsx(Node, {}), children: _jsx(Anchor, {}) }) }), _jsx("table", { style: {
                                        borderCollapse: 'collapse',
                                        marginTop: 20,
                                    }, children: _jsx("tbody", { style: {
                                            borderTop: '1px solid gray',
                                            borderRight: '1px solid gray',
                                        }, children: alignmentGroups.map((alignments, j) => (_jsx("tr", { children: alignments.map((alignment) => (_jsxs("td", { style: {
                                                    padding: '0 10px 10px 10px',
                                                    borderLeft: '1px solid gray',
                                                    borderBottom: '1px solid gray',
                                                    fontSize: 11,
                                                }, children: [_jsxs("pre", { children: ["align=\"", alignment, "\""] }), _jsx("br", {}), _jsx("div", { style: { display: 'inline-block' }, children: _jsx(Stick, { position: position, align: alignment, inline: inline, updateOnAnimationFrame: updateOnAnimationFrame, node: showNode && _jsx(Node, {}), children: _jsx(Anchor, {}) }) })] }, alignment))) }, j))) }) })] }, position))) }, i))) }) })] }));
}
export default PositionAlignOverview;
